<h3>{{Caption()}}</h3>

<DataGridView [DataUrl]="dataurl()" #Grid KeyProperty="versandAuftrag">

</DataGridView>
<ng-template #buttonTemplate let-data>
  <VersandInfoControll [Versand]="data" (Reload)="triggerReload()"></VersandInfoControll>
</ng-template>
